import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';  
import AboutMePage from '../views/AboutMePage.vue';
import AchievementsPage from '../views/AchievementsPage.vue';
import PortfolioPage from '../views/PortfolioPage.vue';
import BlogPage from '../views/BlogPage.vue';
import ContactPage from '../views/ContactPage.vue';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/profile',
    name: 'AboutMePage',
    component: AboutMePage
  },
  {
    path: '/achievements',
    name: 'AchievementsPage',
    component: AchievementsPage
  },
  {
    path: '/portfolio',
    name: 'PortfolioPage',
    component: PortfolioPage
  },
  {
    path: '/blog',
    name: 'BlogPage',
    component: BlogPage
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage
  }

  // Add other routes here
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;